import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooShippingCostPage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-shipping-cost')!;
  return <ArticleLayout article={article} />;
}